import PublicRoomHeader from 'components/views/PublicRoom/_components/PublicRoomHeader';
import PublicRoomHighlights from 'components/views/PublicRoom/_components/PublicRoomHighlights';
import PublicRoomHighlightsAcquisition from 'components/views/PublicRoom/_components/PublicRoomHighlightsAcquisition';
import PublicRoomProfile from 'components/views/PublicRoom/_components/PublicRoomProfile';
import PublicRoomSidebar from 'components/views/PublicRoom/_components/PublicRoomSidebar';
import { Col, Container, Row } from 'react-bootstrap';
import { $detail } from 'signals/global.signals';

const PublicRoomContainer = ({ children }) => (

  <>
    <PublicRoomHeader />
    <div className="main-wrapper w-100 bg-gray-800 pb-80 p-0" style={{ minHeight: 'calc(100vh - 80px)' }}>
      <PublicRoomSidebar />
      <div className="content-wrapper position-relative">
        <div className="overlay position-absolute h-100 w-100" />
        <Container
          fluid
          className="bg-gray-800 px-xxl-120 px-xl-104 px-lg-56 px-md-40 px-24 pt-32 pt-xl-64"
        >
          <Row className="mb-lg-64 mb-32">
            <Col lg={5}>
              <PublicRoomProfile />
            </Col>
            <Col>
              {$detail.value.investmentStage === 'Acquisition' ? <PublicRoomHighlightsAcquisition /> : <PublicRoomHighlights />}
              <div className="text-end mt-16">
                <a className="text-warning" href="https://dealsend.io" target="_blank" rel="noreferrer">Learn more about Dealsend</a>
              </div>
            </Col>
          </Row>
          {children}
        </Container>
      </div>
    </div>
  </>
);

export default PublicRoomContainer;
